import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-hot-toast";
import { ReactComponent as ImagePlacholder } from "../../../../../assets/dashboard/avatar/gallery.svg";
import { ReactComponent as ImagePlacholderDark } from "../../../../../assets/dashboard/avatar/gallery-dark.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";

import { useDispatch, useSelector } from "react-redux";
import { createFavSettings } from "../../../../../redux/slices/appearance/createFavSettingsSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../../../../hooks/useLocales";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";

const favFileTypes = ["ico", "png"];

const FavIconAcc = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const baseUrl = process.env.REACT_APP_API_URL;
  const { translate } = useLocales();
  const [subLoading, setSubLoading] = useState(null);
  const [favIcon, setFavIcon] = useState(null);
  const [showFavicon, setShowFavicon] = useState(null);
  const handleChangFavicon = (file) => {
    setFavIcon(file);
    setShowFavicon(URL.createObjectURL(file));
  };
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item?.coloum_name === "favIcon") {
        const value = JSON.parse(item.coloum_value);
        if (value.favFile) {
          setShowFavicon(baseUrl + "/profile/" + value.favFile);
        } else {
          setShowFavicon(null);
        }
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  const submitHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    if (favIcon) {
      const formData = {
        favIcon: favIcon,
        userId: userId,
        linkId: linkId,
      };
      setSubLoading(true);

      await dispatch(createFavSettings(formData)).then(() => {
        dispatch(gettingSettingUpdataData(user));
        dispatch(getScreenPreviewSetting(pageName));
      });

      setSubLoading(false);
    } else {
      toast.error("Please select a Icon");
    }
  };

  const deleteHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      favIcon: "",
      userId: userId,
      linkId: linkId,
    };

    setSubLoading(true);

    await dispatch(createFavSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });

    setSubLoading(false);
  };

  return (
    <>
      <div className="mt-5">
        {!showFavicon && (
          <FileUploader
            handleChange={handleChangFavicon}
            name="file"
            types={favFileTypes}
            maxSize={2}
            onSizeError={(errorMessage) => toast.error(errorMessage)}
            onTypeError={(errorMessage) => toast.error(errorMessage)}
            children={
              <div>
                <div className="flex items-center justify-center w-full">
                  <div className="flex flex-col items-center justify-center w-full py-[45px] px-5 border-2 border-dark_bg_v4 border-dashed rounded-lg cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary hover:bg-gray-100 dark:border-color_dark dark:hover:border-gray-500 dark:hover:bg-gray-600">
                    <div className="flex flex-col items-center justify-center">
                      <div className="mb-[11px] h-[36px] w-[36]">
                        {darkMode ? (
                          <ImagePlacholderDark />
                        ) : (
                          <ImagePlacholder />
                        )}
                      </div>
                      <p className="text-small3 -tracking-[0.3px] mb-[5px] whitespace-nowrap text-font_light_color dark:text-color_v1_dark">
                        {/* Drop your image here or */}
                        {translate("drop_your_img")}, &nbsp;
                        <span className="text-small3_b text-main_color ">
                          {/* BROWSE IMAGE */}
                          {translate("browse_image")}
                        </span>
                      </p>
                      <p className="text-[10px] text-font_light_color tracking-[-0.3px] leading-[13px] dark:text-font_dark_color">
                        2 MB {/* maximum */}
                        {translate("cms.maximum")}(.png, .gif, .ico)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        )}
        {showFavicon && (
          <div>
            <div className="flex items-center">
              <div className="bg-light_bg_v4 rounded-lg cursor-pointer">
                <img
                  className="h-[60px] w-[60px] sm:h-[68px] sm:w-[68px] object-cover rounded-lg"
                  src={showFavicon}
                  alt=""
                />
              </div>
              <div className="overflow-hidden">
                <FileUploader
                  handleChange={handleChangFavicon}
                  name="file"
                  types={favFileTypes}
                  maxSize={2}
                  onSizeError={(errorMessage) => toast.error(errorMessage)}
                  onTypeError={(errorMessage) => toast.error(errorMessage)}
                  children={
                    <div className="ps-[15px] text-small2_b text-main_color cursor-pointer w-fit">
                      {/* CHOOSE ANOTHER */}
                      {translate("cms.choose_another")}
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex mt-[25px] cursor-pointer items-center justify-end">
        <div
          className="flex justify-center items-center"
          onClick={deleteHandler}
        >
          {darkMode ? <TrashIconDark /> : <TrashIcon />}
          <p className="ps-1.5 pt-1 text-small3_b text-body_copy1_color dark:text-color_v1_dark">
            {/* DELETE */} {translate("biolink_title.delete_cap")}
          </p>
        </div>
        {/* <button
          onClick={() => submitHandler()}
          className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
            subLoading ? "opacity-70" : ""
          } `}
          disabled={!favIcon}
        >
          {subLoading ? (
            <svg
              aria-hidden="true"
              role="status"
              className="inline w-3 h-3 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            "SAVE"
          )}
        </button> */}
        <ExtraSmallFilledButton
          name={`${translate("biolink_title.save_cap")}`}
          buttonType={"button"}
          isLoading={subLoading}
          onClickHandler={submitHandler}
          classes={"ms-3"}
        />
      </div>
    </>
  );
};

export default FavIconAcc;
